import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import Widget from "./components/Widget";
import { log, Style } from "./data/helpers";
var widgetName = "brushfire";
var widgetConfigName = widgetName + "Config";
var defaultconfig = {
    someDefaultConfiguration: false,
};
var widgetComponent;
function app(window) {
    if (window.brushfireDebugMode === true) {
        log("".concat(widgetName, " starting"), Style.brand);
    }
    // If we don't already have a name for widget's global object
    // assigned by the host, then they must be using the simple <script> tag method
    // so we need to get our data out of that tag
    if (!window[widgetName]) {
        if (window.brushfireDebugMode === true) {
            log("Adding ".concat(widgetName, " placeholder..."), Style.brand);
        }
        var tag = document.getElementById(widgetName + "-Script");
        if (!tag) {
            log("Could not find ".concat(widgetName, " script tag"), Style.error);
            throw Error("Cannot find script tag with id {$widgetName}-Script");
        }
        var rawData = tag.getAttribute("data-config");
        rawData = (rawData === null || rawData === void 0 ? void 0 : rawData.replace(/'/g, '"')) || "";
        var data = JSON.parse(rawData);
        window[widgetName] = data.name;
        var placeholder_1 = { q: [] };
        placeholder_1.q.push(["init", data.config]);
        window[window[widgetName]] = placeholder_1;
        log("".concat(widgetName, " placeholder added"), Style.brand);
    }
    var placeholder = window[window[widgetName]];
    // override temporary (until the app loaded) handler
    // for widget's API calls
    window[window[widgetName]] = apiHandler;
    window[widgetConfigName] = defaultconfig;
    if (placeholder) {
        var queue = placeholder.q;
        if (queue) {
            log("".concat(widgetName, " placeholder queue found"), Style.brand);
            for (var i = 0; i < queue.length; i++) {
                apiHandler(queue[i][0], queue[i][1]);
            }
        }
    }
    else {
        log("".concat(widgetName, " placeholder not found"), Style.error);
    }
}
/**
    Method that handles all API calls
*/
function apiHandler(api, params) {
    var _a, _b, _c, _d;
    if (params.debugMode === "true" || params.debugMode === true) {
        window.brushfireDebugMode = true;
    }
    if (window.brushfireDebugMode === true) {
        log("Process API method:  ".concat(api), Style.brand);
    }
    if (!api)
        throw Error("API method required");
    api = api.toLowerCase();
    //eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    var config = window[widgetConfigName];
    if (api === "init") {
        config = Object.assign({}, config, params);
        //eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        window[widgetConfigName] = config;
        // get a reference to the created widget component so we can
        // call methods as needed
        widgetComponent = React.createRef();
        var root = createRoot(document.getElementById(config.targetElementId));
        root.render(_jsx(Widget, { ref: widgetComponent, pageTitle: "Brushfire Widget" }));
    }
    else if (api === "action") {
        switch (params.action) {
            case "setHost":
                if (!(widgetComponent === null || widgetComponent === void 0 ? void 0 : widgetComponent.current)) {
                    setTimeout(function () {
                        apiHandler(api, params);
                    }, 200);
                }
                (_a = widgetComponent === null || widgetComponent === void 0 ? void 0 : widgetComponent.current) === null || _a === void 0 ? void 0 : _a.setHost(params.host);
                break;
            case "setAccount":
                if (!(widgetComponent === null || widgetComponent === void 0 ? void 0 : widgetComponent.current)) {
                    setTimeout(function () {
                        apiHandler(api, params);
                    }, 200);
                }
                (_b = widgetComponent === null || widgetComponent === void 0 ? void 0 : widgetComponent.current) === null || _b === void 0 ? void 0 : _b.setAccount(params.account);
                break;
            case "setWidgetId":
                if (!(widgetComponent === null || widgetComponent === void 0 ? void 0 : widgetComponent.current)) {
                    setTimeout(function () {
                        apiHandler(api, params);
                    }, 200);
                }
                (_c = widgetComponent === null || widgetComponent === void 0 ? void 0 : widgetComponent.current) === null || _c === void 0 ? void 0 : _c.setWidgetId(params.widgetId, params.widgetConfig);
                break;
            case "setDarkMode":
                if (!(widgetComponent === null || widgetComponent === void 0 ? void 0 : widgetComponent.current)) {
                    setTimeout(function () {
                        apiHandler(api, params);
                    }, 200);
                }
                (_d = widgetComponent === null || widgetComponent === void 0 ? void 0 : widgetComponent.current) === null || _d === void 0 ? void 0 : _d.setDarkMode(params.darkMode);
                break;
            default:
                throw Error("Method ".concat(api, " is not supported"));
        }
    }
}
app(window);
export default app;
